import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";
import { toast } from "sonner";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [user, loading, navigate]);

  useEffect(() => {
    if (user) api.get("/wishlist").then(r => setItems(r.data)).catch(()=>{});
  }, [user]);

  const remove = async (product) => {
    try {
      await api.delete(`/wishlist/${product.product_id}`);
      setItems(items.filter(p => p.product_id !== product.product_id));
    } catch { toast.error("Erreur"); }
  };

  if (!user) return <div className="p-20 text-center">Chargement…</div>;

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-6 lg:py-10 fade-in has-bottom-nav" data-testid="wishlist-page">
      <p className="label mb-2">Mes coups de cœur</p>
      <h1 className="text-3xl lg:text-5xl font-black tracking-tighter mb-8">Favoris</h1>
      {items.length === 0 ? (
        <div className="text-center py-16 border-2 border-dashed border-black">
          <Heart size={32} strokeWidth={2} className="mx-auto mb-4" style={{color:"var(--color-coral)"}}/>
          <p className="text-2xl font-black mb-3">Aucun favori pour l'instant</p>
          <p className="text-sm text-[color:var(--color-text-muted)]">Tape sur le cœur quand tu craques.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {items.map(p => <ProductCard key={p.product_id} product={p} onWishlist={remove} isWishlisted={true}/>)}
        </div>
      )}
    </div>
  );
}
